import { axios } from '@/utils/request'

// 查询门店列表
export function getBranchList(params) {
  return axios({
    url: '/branches',
    method: 'get',
    params: params
  })
}

// 添加门店/修改门店
export function updateBranch(params) {
  return axios({
    url: '/branch/save',
    method: 'post',
    data: params
  })
}

// 删除门店
export function deleteBranch(branch_id) {
  return axios({
    url: `/branch/${branch_id}`,
    method: 'delete'
  })
}

// 查询门店管理员
export function getBranchAdminList(params) {
  return axios({
    url: '/clerk',
    method: 'get',
    params: params
  })
}

// 门店机器编码管理
export function getBranchIdentify(params) {
  return axios({
    url: '/meter',
    method: 'put',
    data: params
  })
}

//显示/隐藏门店
export function setVisibleBranch(id){
  return axios({
    url: '/branch/visible/' + id,
    method: 'post',
  })
}

export function setOutletsBranch(id){
  return axios({
    url: '/branch/is_outlets/' + id,
    method: 'post',
  })
}